import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { closeBulkTradeRfs } from '@/store/bulkTrade/api/requestBulkTradeRfs.ts';

export type CancelBulkTradeRfsBody = {
  // useful to have a fixedCacheKey to remove the mutation result from the cache
  tabId: string;
  rfsId: string;
};

export type CancelBulkTradeRfsResponse = {};

export const cancelBulkTradeRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<CancelBulkTradeRfsResponse, CancelBulkTradeRfsBody>({
    query: (body) => {
      return {
        url: '/fxBulk/rfs/cancel',
        method: 'POST',
        body: {
          rfsId: body.rfsId,
        },
      };
    },

    onQueryStarted({ tabId }, { dispatch }): Promise<void> | void {
      // close the RFS stream (from the request)
      closeBulkTradeRfs(tabId, dispatch);
    },
  });
};
